export default __webpack_public_path__ + "static/dodo-navy-275610f812f6a0e71a40a350b09e6453.svg";